import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../../components/Footer'; 

// Update support categories with links
const supportCategories = [
  {
    title: 'Başlarken',
    icon: '🚀',
    description: 'Portföy yönetimi ve kullanım kılavuzu',
    link: '/support/getting-started',
    items: [
      'Hesap oluşturma',
      'İlk portföyünüzü oluşturma',
      'Varlık ekleme',
      'Temel özellikler'
    ]
  },
  {
    title: 'Portföy Yönetimi',
    icon: '📊',
    description: 'Portföy takibi ve rebalancing işlemleri',
    link: '/support/portfolio-management',
    items: [
      'Varlık takibi',
      'Rebalancing nasıl yapılır',
      'Portföy analizi',
      'Raporlama'
    ]
  },
  {
    title: 'Güvenlik',
    icon: '🔒',
    description: 'Hesap güvenliği ve gizlilik',
    link: '/support/security',
    items: [
      'İki faktörlü doğrulama',
      'Şifre yönetimi',
      'Veri güvenliği',
      'Gizlilik politikası'
    ]
  },
  {
    title: 'Ödeme İşlemleri',
    icon: '💳',
    description: 'Ödeme ve fatura işlemleri',
    link: '/support/payment',
    items: [
      'Ödeme yöntemleri',
      'Abonelik iptali',
      'İade işlemleri',
      'Ödeme sorunları',
    ]
  }
];

const SupportIndex = () => {
  const [searchQuery, setSearchQuery] = useState('');

  const filteredCategories = supportCategories.map(category => ({
    ...category,
    items: category.items.filter(item =>
      item.toLowerCase().includes(searchQuery.toLowerCase())
    )
  })).filter(category =>
    category.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
    category.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
    category.items.length > 0
  );

  return (
    <div className="min-h-screen bg-white dark:bg-[#0A0E23] pt-20 pb-12"> {/* Added pt-20 */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">
            Nasıl Yardımcı Olabiliriz?
          </h1>
          <p className="text-xl text-gray-600 dark:text-gray-400">
            Portföy yönetiminiz için ihtiyacınız olan tüm bilgiler burada
          </p>
        </div>

        {/* Search Bar */}
        <div className="max-w-2xl mx-auto mb-16">
          <div className="relative">
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Aradığınız konuyu yazın..."
              className="w-full px-6 py-4 text-lg border border-gray-300 dark:border-gray-700 rounded-full 
                       bg-white dark:bg-gray-800 text-gray-900 dark:text-white
                       focus:ring-2 focus:ring-blue-500 focus:outline-none"
            />
            <button className="absolute right-4 top-1/2 transform -translate-y-1/2
                           text-gray-400 hover:text-gray-600 dark:hover:text-gray-300">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </button>
          </div>
        </div>

        {/* Categories Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8">
          {filteredCategories.map((category, index) => (
            <div key={index} className="bg-gray-50 dark:bg-gray-800/50 rounded-xl p-8 
                                    border border-gray-200 dark:border-gray-700 hover:border-blue-500 
                                    dark:hover:border-blue-500 transition-all duration-200">
              <div className="flex items-start space-x-4">
                <div className="text-4xl">{category.icon}</div>
                <div className="flex-1">
                  <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
                    {category.title}
                  </h3>
                  <p className="text-gray-600 dark:text-gray-400 mb-4">
                    {category.description}
                  </p>
                  <ul className="space-y-2">
                    {category.items.map((item, itemIndex) => (
                      <li key={itemIndex}>
                        <Link 
                         // to={`${category.link}#${item.toLowerCase().replace(/\s+/g, '-')}`}
                          className="text-blue-600 dark:text-blue-400 hover:text-blue-800 
                                     dark:hover:text-blue-300 flex items-center"
                        >
                          <span className="mr-2">→</span>
                          {item}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Contact Section */}
        <div className="mt-16 text-center">
          <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">
            Hala yardıma mı ihtiyacınız var?
          </h2>
          <p className="text-gray-600 dark:text-gray-400 mb-6">
            Ekibimiz size yardımcı olmak için hazır
          </p>
          <Link 
            to="/contact"
            className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-full 
                     text-white bg-blue-600 hover:bg-blue-700 transition-colors duration-200"
          >
            Bizimle İletişime Geçin
          </Link>
        </div>
      </div>
<br></br>
<br></br>
            {/* Footer */}
            <Footer />
    </div>
  );
};

export default SupportIndex;